/* Pearl and Post Atelier, agent navigatie (opdracht 4, fase 2): gedrag van header, menulade, megamenu en zoekpaneel.
   OPDRACHT-4 5.3: header verdwijnt bij naar beneden scrollen en komt terug bij naar boven scrollen; lade sluit met Escape
   en een tik erbuiten, pagina erachter scrolt niet mee; megamenu opent bij hover met korte vertraging en bij klik,
   te bedienen met Tab, Enter en Escape; zoeken opent met de cursor in het veld, chips, en suggesties tijdens het typen.
   Zet --pp-header-offset op <html> (hoogte van de zichtbare vaste header, 0 als hij verborgen is) voor andere vaste balken. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pp-nav]');
  if (!root || root.__ppNav) return;
  root.__ppNav = true;
  var html = document.documentElement;
  var section = root.parentElement;
  if (section) section.classList.add('pp-nav-section');
  var sticky = section && section.parentElement && section.parentElement !== document.body ? section.parentElement : section;
  if (sticky) sticky.classList.add('pp-nav-sticky');
  var naturalTop = 0;
  function barHeight() { return sticky && sticky !== section ? Math.max(0, sticky.offsetHeight - section.offsetHeight) : 0; }
  function setBar() { if (sticky) sticky.style.setProperty('--pp-bar-h', barHeight() + 'px'); }
  var canDialog = typeof HTMLDialogElement === 'function' && 'showModal' in HTMLDialogElement.prototype;

  function openDialog(d) {
    if (!d) return;
    if (canDialog) { if (!d.open) d.showModal(); } else { d.setAttribute('open', ''); }
    html.classList.add('pp-nav-lock');
  }
  function closeDialog(d) {
    if (!d) return;
    if (canDialog && d.open) d.close(); else { d.removeAttribute('open'); d.dispatchEvent(new Event('close')); }
  }
  function anyOpen() {
    return !!root.querySelector('dialog[open]');
  }

  /* ---------- header verbergen bij naar beneden scrollen ---------- */
  var lastY = window.scrollY || 0, hidden = false, ticking = false;
  function setHidden(h) {
    if (h === hidden) return;
    hidden = h;
    if (sticky) sticky.classList.toggle('is-pp-hidden', h);
    setOffset();
  }
  function setOffset() {
    var hgt = section ? section.offsetHeight : 0;
    html.style.setProperty('--pp-header-offset', (hidden ? 0 : hgt) + 'px');
  }
  function onScroll() {
    ticking = false;
    var y = window.scrollY || 0;
    if (anyOpen() || html.hasAttribute('data-scroll-locked') || root.querySelector('[data-pp-menu-panel]:not([hidden])') || root.contains(document.activeElement) && document.activeElement !== document.body && html.classList.contains('pp-kbd')) {
      lastY = y; return;
    }
    var limit = naturalTop + (sticky ? sticky.offsetHeight : 0);
    if (y <= limit) setHidden(false);
    else if (y > lastY + 6) setHidden(true);
    else if (y < lastY - 6) setHidden(false);
    lastY = y;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); } }, { passive: true });
  window.addEventListener('resize', function () { setBar(); setOffset(); });
  setBar();
  if ((window.scrollY || 0) === 0 && sticky) naturalTop = Math.max(0, Math.round(sticky.getBoundingClientRect().top));
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab') html.classList.add('pp-kbd'); });
  document.addEventListener('pointerdown', function () { html.classList.remove('pp-kbd'); });
  root.addEventListener('focusin', function () { setHidden(false); });
  setOffset();

  /* ---------- menulade ---------- */
  var drawer = root.querySelector('[data-pp-drawer]');
  var drawerBtn = root.querySelector('[data-pp-drawer-open]');
  var drawerScroll = drawer ? drawer.querySelector('[data-pp-drawer-scroll]') : null;
  function showLevel(id, focusSel) {
    if (!drawer) return;
    drawer.querySelectorAll('[data-pp-level]').forEach(function (l) { l.hidden = l.id !== id; });
    drawer.querySelectorAll('[data-pp-sub]').forEach(function (b) { b.setAttribute('aria-expanded', b.getAttribute('data-pp-sub') === id ? 'true' : 'false'); });
    if (drawerScroll) drawerScroll.scrollTop = 0;
    var f = focusSel ? drawer.querySelector(focusSel) : null;
    if (f) f.focus({ preventScroll: true });
  }
  if (drawer && drawerBtn) {
    drawerBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeMenus();
      showLevel('pp-sub-root');
      openDialog(drawer);
      drawerBtn.setAttribute('aria-expanded', 'true');
      var c = drawer.querySelector('[data-pp-drawer-close]');
      if (c) c.focus({ preventScroll: true });
    });
    drawer.addEventListener('close', function () {
      if (!anyOpen()) html.classList.remove('pp-nav-lock');
      drawerBtn.setAttribute('aria-expanded', 'false');
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) { closeDialog(drawer); return; }
      var sub = e.target.closest('[data-pp-sub]');
      if (sub) { showLevel(sub.getAttribute('data-pp-sub'), '#' + sub.getAttribute('data-pp-sub') + ' [data-pp-back]'); return; }
      var back = e.target.closest('[data-pp-back]');
      if (back) {
        var from = back.closest('[data-pp-level]');
        showLevel('pp-sub-root', from ? '[data-pp-sub="' + from.id + '"]' : null);
        return;
      }
      if (e.target.closest('[data-pp-drawer-close]')) closeDialog(drawer);
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !canDialog) closeDialog(drawer);
    });
  }

  /* ---------- desktop: megamenu en uitklapmenu ---------- */
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-pp-menu-item]'));
  function openItem(it, how) {
    items.forEach(function (o) { if (o !== it) closeItem(o); });
    var b = it.querySelector('[data-pp-menu-btn]'), p = it.querySelector('[data-pp-menu-panel]');
    if (!b || !p) return;
    p.hidden = false;
    b.setAttribute('aria-expanded', 'true');
    it.__how = how;
    setHidden(false);
  }
  function closeItem(it) {
    var b = it.querySelector('[data-pp-menu-btn]'), p = it.querySelector('[data-pp-menu-panel]');
    clearTimeout(it.__t);
    if (!b || !p) return;
    p.hidden = true;
    b.setAttribute('aria-expanded', 'false');
    it.__how = null;
  }
  function closeMenus() { items.forEach(closeItem); }
  items.forEach(function (it) {
    var b = it.querySelector('[data-pp-menu-btn]');
    var hoverOk = window.matchMedia('(hover: hover) and (pointer: fine)');
    it.addEventListener('mouseenter', function () {
      if (!hoverOk.matches) return;
      clearTimeout(it.__t);
      var already = items.some(function (o) { return o !== it && o.__how; });
      it.__t = setTimeout(function () { openItem(it, 'hover'); }, already ? 60 : 160);
    });
    it.addEventListener('mouseleave', function () {
      if (!hoverOk.matches) return;
      clearTimeout(it.__t);
      if (it.__how === 'hover') it.__t = setTimeout(function () { closeItem(it); }, 220);
    });
    b.addEventListener('click', function (e) {
      e.preventDefault();
      clearTimeout(it.__t);
      if (it.__how === 'click' || it.__how === 'key') closeItem(it);
      else openItem(it, e.detail === 0 ? 'key' : 'click');
    });
    it.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && it.__how) { e.preventDefault(); closeItem(it); b.focus(); }
    });
    it.addEventListener('focusout', function (e) {
      if (it.__how && e.relatedTarget && !it.contains(e.relatedTarget)) closeItem(it);
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-pp-menu-item]')) closeMenus();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenus(); });

  /* ---------- zoekpaneel ---------- */
  var search = root.querySelector('[data-pp-search]');
  var searchBtn = root.querySelector('[data-pp-search-open]');
  if (search && searchBtn) {
    var input = search.querySelector('[data-pp-search-input]');
    var start = search.querySelector('[data-pp-search-start]');
    var results = search.querySelector('[data-pp-search-results]');
    var empty = search.querySelector('[data-pp-search-empty]');
    var none = search.querySelector('[data-pp-search-none]');
    var status = search.querySelector('[data-pp-search-status]');
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var timer = null, ctrl = null, lastQ = '';
    var money = (function () {
      try { var f = new Intl.NumberFormat('en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }); return function (v) { return f.format(Number(v)); }; }
      catch (e) { return function (v) { return '£' + Number(v).toFixed(2); }; }
    })();
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var img = function (u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
    function view(which) {
      start.hidden = which !== 'start';
      results.hidden = which !== 'results';
      empty.hidden = which !== 'empty';
    }
    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var prods = r.products || [], cols = r.collections || [], pages = r.pages || [];
      if (!prods.length && !cols.length && !pages.length) {
        none.textContent = 'No results for “' + q + '”. Try one of these:';
        view('empty');
        status.textContent = 'No results';
        return;
      }
      var h = '<div class="pp-res__cols"><div>';
      if (prods.length) {
        h += '<div class="pp-res__group"><p class="pp-search__label" id="pp-res-p">Products</p><ul role="list" aria-labelledby="pp-res-p">';
        prods.forEach(function (p) {
          var src = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          var alt = p.featured_image && p.featured_image.alt ? p.featured_image.alt : p.title;
          h += '<li><a class="pp-res__prod" href="' + esc(p.url) + '"><span class="pp-res__img">' + (src ? '<img src="' + esc(img(src, 120)) + '" width="60" height="60" alt="' + esc(alt) + '" loading="lazy">' : '') + '</span><span class="pp-res__txt"><span class="pp-res__title">' + esc(p.title) + '</span><span class="pp-res__price">' + esc(money(p.price)) + '</span></span></a></li>';
        });
        h += '</ul></div>';
      }
      h += '</div><div class="pp-res__links">';
      if (cols.length) {
        h += '<div class="pp-res__group"><p class="pp-search__label" id="pp-res-c">Collections</p><ul role="list" aria-labelledby="pp-res-c">';
        cols.forEach(function (c) { h += '<li><a class="pp-row pp-row--small" href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; });
        h += '</ul></div>';
      }
      if (pages.length) {
        h += '<div class="pp-res__group"><p class="pp-search__label" id="pp-res-g">Pages</p><ul role="list" aria-labelledby="pp-res-g">';
        pages.forEach(function (c) { h += '<li><a class="pp-row pp-row--small" href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; });
        h += '</ul></div>';
      }
      h += '</div></div><div class="pp-res__all"><a class="pp-row pp-row--small" href="' + esc(base + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last') + '">See all results for “' + esc(q) + '”</a></div>';
      results.innerHTML = h;
      view('results');
      status.textContent = (prods.length + cols.length + pages.length) + ' suggestions';
    }
    function suggest() {
      var q = input.value.trim();
      if (q === lastQ) return;
      lastQ = q;
      if (!q) { view('start'); status.textContent = ''; return; }
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = base + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal, headers: { Accept: 'application/json' } } : {})
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (q === input.value.trim()) render(q, d || {}); })
        .catch(function () {});
    }
    searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeMenus();
      if (drawer && drawer.open) closeDialog(drawer);
      openDialog(search);
      searchBtn.setAttribute('aria-expanded', 'true');
      input.focus();
      if (input.value) { try { input.select(); } catch (er) {} }
    });
    search.addEventListener('close', function () {
      if (!anyOpen()) html.classList.remove('pp-nav-lock');
      searchBtn.setAttribute('aria-expanded', 'false');
    });
    search.addEventListener('click', function (e) {
      if (e.target === search) { closeDialog(search); return; }
      if (e.target.closest('[data-pp-search-close]')) closeDialog(search);
    });
    search.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); closeDialog(search); } });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(suggest, 180); });
  }

  /* Winkelwagenlade van het thema opent: alles van de navigatie dicht */
  document.addEventListener('theme:cart-drawer:open', function () { closeMenus(); if (drawer) closeDialog(drawer); if (search) closeDialog(search); });
})();
